<div class="row">
    <div [ngClass]="isEdit || isAdd || isAssign ? 'col-sm-6' : 'col-sm-11'">
        <kendo-grid #tableGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [pageable]="true"
                    [sortable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem.groupId)"><i class="fas fa-pencil-alt"></i></button>
                    <button type="button" class="btn btn-sml btn-secondary m-1" title="Assign" tabindex="-1" (click)="assign(dataItem.groupId)"><i class="fas fa-users"></i></button>
                    <!--<button type="button" class="btn btn-sml btn-danger m-1" title="Delete" tabindex="-1" (click)="delete(dataItem.groupId)"><i class="fas fa-times"></i></button>-->
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="groupId" title="ID"></kendo-grid-column>
            <kendo-grid-column field="erpGroupId" title="ERP Group ID"></kendo-grid-column>
            <kendo-grid-column field="name" title="Group Name"></kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-1" *ngIf="!isEdit && !isAdd && !isAssign">
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isEdit && !isAdd"><i class="fas fa-plus"></i></button>
    </div>

    <div class="col-sm-6" *ngIf="isEdit || isAdd">
        <!-- Edit form -->
        <employee-group-form [tableID]="tableID" (onRefresh)="cancelEdit()"></employee-group-form>
    </div>

    <div class="col-sm-6" *ngIf="isAssign">
        <!-- Edit form -->
        <employee-group-assign [tableID]="tableID" (onRefresh)="cancelEdit()"></employee-group-assign>
    </div>
</div>
